
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Line, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

@Component
class LineChart extends Vue.extend({
  mixins: [reactiveProp],
  extends: Line,
  props: {
    chartData: { type: Object, required: true },
    options: { type: Object, required: true },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
}) {}

@Component({
  components: { LineChart },
})
export default class BandwidthLineChart extends Vue {
  @Prop({ type: Array, required: true }) readonly points!: Array<{ x: Date; y: number }>;

  get chartData() {
    return {
      datasets: [
        {
          data: this.points,
          borderColor: '#0CA0CA',
          borderWidth: 2,
          lineTension: 0.15,
          pointRadius: 3,
          pointHitRadius: 10,
          pointHoverRadius: 6,
          pointHoverBackgroundColor: '#ffffff',
          pointHoverBorderColor: '#0CA0CA',
          pointHoverBorderWidth: 2,
          fill: true,
          backgroundColor: 'rgba(12, 160, 202, 0.12)',
        },
      ],
    };
  }

  get options() {
    return {
      responsive: true,
      maintainAspectRatio: false,

      legend: {
        display: false,
        labels: {
          fontColor: 'rgba(255,255,255,0.65)',
        },
      },

      tooltips: {
        intersect: false,
        mode: 'index',
        callbacks: {
          label: (t: any) => ` ${Number(t.yLabel).toFixed(2)} MB`,
        },
      },

      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: 'day',
              tooltipFormat: 'YYYY-MM-DD',
              displayFormats: {
                day: 'DD MMM',
              },
            },
            ticks: {
              fontColor: 'rgba(255,255,255,0.55)',
              source: 'data',
              autoSkip: false,
              maxRotation: 45,
              minRotation: 45,
            },
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              min: 0,
              suggestedMax: 1,
              fontColor: 'rgba(255,255,255,0.55)',
              callback: (v: number) => `${Number(v).toFixed(1)} MB`,
            },
            gridLines: {
              color: 'rgba(255,255,255,0.06)',
              drawBorder: false,
            },
          },
        ],
      },
    };
  }
}
